import api, { transformRequest, transformResponse } from "services/api";

export const operatingStatesApi = api
  .enhanceEndpoints({ addTagTypes: ["OperatingState"] })
  .injectEndpoints({
    endpoints: (build) => ({
      fetchOperatingStates: build.query({
        query: () => `/api/v1/core/operating-states/`,
        transformResponse: (response) => transformResponse(response),
        providesTags: (result) =>
          result
            ? [
                ...result.map(({ id }) => ({ type: "OperatingState", id })),
                { type: "OperatingState", id: "LIST" },
              ]
            : [{ type: "OperatingState", id: "LIST" }],
      }),
      bulkUpdateOperatingStates: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/operating-states/bulk-update/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        transformResponse: (response) => transformResponse(response),
        invalidatesTags: [{ type: "OperatingState", id: "LIST" }],
      }),
    }),
  });

export const {
  useFetchOperatingStatesQuery,
  useLazyFetchOperatingStatesQuery,
  useBulkUpdateOperatingStatesMutation,
} = operatingStatesApi;
